<template>
  <div class="games">
    <q-inner-loading :showing="loading" class="fullscreen">
      <q-spinner size="50px" color="secondary" />
    </q-inner-loading>
    <AllGamesFilters
      :categoryList="categories"
      :currentCategory="selectedCategory"
      @categoryChange="updateCategory"
      :currentSearchTerm="selectedSearchTerm"
      @searchTermChange="updateSearchTerm"
      :providersList="providers"
      :currentProviders="selectedProviders"
      @providersChange="updateProviders"
      @userTypeChange="updateUserType"
    />

    <section class="games-category" v-if="seeGames">
      <div class="games-category__count">
        Games: <span>{{ filteredGames.length }}</span>
      </div>
      <q-intersection v-for="(game, index) in filteredGames" :key="index"
        ><AllGamesGameTile
          :game="game"
          @readMoreClick="openGameItem"
          @demoClick="openDemo"
      /></q-intersection>

      <q-page-scroller
        position="bottom-right"
        :scroll-offset="150"
        :offset="[18, 18]"
      >
        <q-btn fab icon="keyboard_arrow_up" color="secondary" />
      </q-page-scroller>
    </section>
    <IframeDialog :open.sync="dialogOpen" :url="url" :title="dialogTitle" />
  </div>
</template>

<script>
import router from "@/router";
import { formatUrl } from "@/utils/formatText";
import { filterBuilder, gameDemoInIframeMatchProvider } from "./AllGames.utils";
import AllGamesFilters from "./AllGamesFilters.vue";
import AllGamesGameTile from "./AllGamesGameTile.vue";
import { generateDemoGameUrl } from "@/utils/formatGameUrl";
import IframeDialog from "@/components/dialog/Iframe.vue";
export default {
  name: "AllGames",
  components: { AllGamesFilters, AllGamesGameTile, IframeDialog },
  data() {
    return {
      games: [],
      categories: [],
      providers: [],
      userTypes: [],
      selectedCategory: null,
      selectedUserTypes: [],
      selectedProviders: [],
      selectedSearchTerm: null,
      loading: true,
      dialogOpen: false,
      dialogTitle: "",
      url: "",
    };
  },

  methods: {
    generateDemoGameUrl,
    async fetchAllGames() {
      const payload = {
        link: "game-infos",
      };
      this.$store
        .dispatch("fetchStrapiContent", payload)
        .then((response) => {
          this.games = (response && response.data) || [];
          this.loading = false;
        })
        .catch((error) => {
          this.errors.push(error);
          this.games = null;
        });
    },
    async fetchAllCategories() {
      const payload = {
        link: "game-categories",
      };
      this.$store
        .dispatch("fetchStrapiContent", payload)
        .then((response) => {
          this.categories = this.sortCategories((response && response.data)) || [];
        })
        .catch((error) => {
          this.errors.push(error);
          this.categories = null;
        });
    },
    async fetchAllProviders() {
      const payload = {
        link: "game-providers",
      };
      this.$store
        .dispatch("fetchStrapiContent", payload)
        .then((response) => {
          this.providers = (response && response.data) || [];
        })
        .catch((error) => {
          this.errors.push(error);
          this.providers = null;
        });
    },
    async fetchUserTypes() {
      const payload = {
        link: "user-types",
      };
      await this.$store
        .dispatch("fetchStrapiContent", payload)
        .then((response) => {
          this.userTypes = (response && response.data) || [];
        })
        .catch((error) => {
          this.errors.push(error);
        });
    },
    updateCategory(category) {
      this.selectedCategory = category;
      this.$store.commit("SET_CATEGORY_NEW", {
        selectedCategoryNew: category,
      });
    },
    updateUserType(userType) {
      this.selectedUserTypes = userType;
    },
    updateProviders(provider) {
      this.selectedProviders = provider;
      this.$store.commit("SET_PROVIDER_NEW", {
        selectedProvidersNew: provider,
      });
    },
    updateSearchTerm(searchTerm) {
      this.selectedSearchTerm = searchTerm;
      this.$store.commit("SET_SEARCH_NEW", {
        selectedSearchNew: searchTerm,
      });
    },
    sortCategories(allCategories) {
      const filteredCategories = allCategories.filter(
        (category) => category.game_infos.length > 0
      );
      const formatCategories = [...filteredCategories];
      return formatCategories;
    },
    openGameItem(id, gameName) {
      // format game name for url
      const name = formatUrl(gameName);
      // Push game id and name into the SingleGame component and render the new page
      router.push({
        name: "Game",
        params: { id, name },
        query: { name: name },
      });
    },
    openDemo(url, demoIframeEnabled, name) {
      if (!demoIframeEnabled) {
        window.open(url, "_blank");
      }
      if (demoIframeEnabled) {
        this.dialogOpen = true;
        this.dialogTitle = name + " Demo";
        this.url = url;
      }
    },
  },

  mounted() {
    // Keep filter state when leaving page
    this.selectedCategory =
      this.$store.getters.getCategoryNew || this.selectedCategory;
    this.fetchAllCategories();
    this.fetchAllGames();
    this.fetchUserTypes();
    this.fetchAllProviders();
    this.selectedSearchTerm =
      this.$store.getters.getSelectedSearchNew || this.selectedSearchTerm;
    this.selectedProviders =
      this.$store.getters.getSelectedProvidersNew || this.selectedProviders;
  },

  computed: {
    filteredGames() {
      const filterer = filterBuilder(
        this.selectedCategory,
        this.selectedUserTypes,
        this.selectedProviders,
        this.selectedSearchTerm
      );
      return this.games.filter(filterer).map((game) => {
        return {
          ...game,
          resolvedDemoUrl: generateDemoGameUrl(
            game.game_provider.GameProviderURL,
            game.GameDemoLink
          ),
          openDemoInIframe: this.getGameDemoIframe(game.game_provider.id),
        };
      });
    },

    getGameDemoIframe() {
      return gameDemoInIframeMatchProvider(this.providers);
    },

    seeGames() {
      return this.selectedUserTypes.length || false;
    },
  },
};
</script>
